/* Productfoto's per rij laten binnenkomen, zoals het oude Reeder-thema (Impulse: data-aos="row-of-4" + image-fade-in).
   Een kaart blijft onzichtbaar tot zijn rij in beeld komt én de foto's van die rij geladen zijn; dan fadet de rij in
   0,5 s in, per kolom 120 ms later. Geen grijze vlakken en geen foto's die een voor een binnenploppen.
   Werkt voor elke product-card (collectie, zoeken, homepage-rijen, aanbevelingen), ook voor kaarten die later bijkomen. */
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('rf-reveal-aan');
  var geladen = function (img) {
    if (!img || (img.complete && img.naturalWidth)) return Promise.resolve();
    return new Promise(function (r) { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); });
  };
  var toon = function (rij) {
    rij.sort(function (a, b) { return a.getBoundingClientRect().left - b.getBoundingClientRect().left; });
    rij.forEach(function (k, n) { k.style.setProperty('--rf-vertraging', (n * 120) + 'ms'); k.classList.add('rf-in'); });
  };
  var io = new IntersectionObserver(function (entries) {
    var rijen = {};
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var t = Math.round(e.target.getBoundingClientRect().top / 20);
      (rijen[t] = rijen[t] || []).push(e.target);
    });
    Object.keys(rijen).forEach(function (t) {
      var rij = rijen[t];
      var klaar = false;
      var eens = function () { if (!klaar) { klaar = true; toon(rij); } };
      Promise.all(rij.map(function (k) { return geladen(k.querySelector('.card-gallery img')); })).then(eens);
      setTimeout(eens, 1800); // vangnet: nooit langer dan 1,8 s een leeg vak
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
  var meld = function () {
    document.querySelectorAll('product-card:not([data-rf-reveal])').forEach(function (k) { k.setAttribute('data-rf-reveal', ''); io.observe(k); });
  };
  var wacht = null;
  meld();
  new MutationObserver(function () { clearTimeout(wacht); wacht = setTimeout(meld, 60); }).observe(document.body, { childList: true, subtree: true });
})();
